export default "__VITE_ASSET__8ab2e4e4__"